// src/components/importData/utils/parsers/index.js
import { parseIntegralPDF } from './integralParser';
import { parseAkbankCSV } from './akbankParser';
import { parseEYatirimciXLS } from './eyatirimciParser';
import { SOURCE_OPTIONS, ERROR_MESSAGES } from '../constants';

export const handleFile = async (file, source) => {
  try {
    let stocks;
    const selectedSource = SOURCE_OPTIONS.find(opt => opt.id === source);
    
    if (!selectedSource) {
      throw new Error(ERROR_MESSAGES.NO_SOURCE);
    }

    const fileExtension = file.name.split('.').pop().toLowerCase();
    const acceptedFormats = selectedSource.acceptedFormats
      .split(',')
      .map(format => format.trim().replace('.', ''));
    
    if (!acceptedFormats.includes(fileExtension)) {
      throw new Error(ERROR_MESSAGES.INVALID_FORMAT(selectedSource.referenceFile));
    }
    
    switch (source) {
      case 'integral':
        stocks = await parseIntegralPDF(file);
        break;
        
      case 'akbank':
        stocks = await parseAkbankCSV(file);
        break;
        
      case 'eyatirimci':
        stocks = await parseEYatirimciXLS(file);
        break;
        
      default:
        throw new Error(ERROR_MESSAGES.NO_SOURCE);
    }

    if (!stocks || stocks.length === 0) {
      throw new Error(ERROR_MESSAGES.NO_DATA);
    }

    return stocks;

  } catch (error) {
    console.error('Dosya işleme hatası:', error);
    throw error;
  }
};

// Export individual parsers if needed
export { parseIntegralPDF, parseAkbankCSV, parseEYatirimciXLS };